/** Sentry tag marking an error caused by the frontend and the deployed code drifting apart. */
export const DEPLOY_SKEW_TAG = 'deploy_skew'

const CHUNK_LOAD_ERROR_MESSAGES = [
   'Failed to fetch dynamically imported module',
   'error loading dynamically imported module',
   'Importing a module script failed',
   'Unable to preload CSS',
]

/** True when an error is a browser's failure to load a lazily imported chunk. */
export function isChunkLoadError(error: unknown): boolean {
   if (!(error instanceof Error)) return false
   return error.name === 'ChunkLoadError' || CHUNK_LOAD_ERROR_MESSAGES.some(message => error.message.includes(message))
}
